(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('CurveLimitsDetailController', CurveLimitsDetailController);

    CurveLimitsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CurveLimits'];

    function CurveLimitsDetailController($scope, $rootScope, $stateParams, previousState, entity, CurveLimits) {
        var vm = this;

        vm.curveLimits = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:curveLimitsUpdate', function(event, result) {
            vm.curveLimits = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
